import { render, staticRenderFns } from "./MaydayNodeMainBody.vue?vue&type=template&id=50e3a3ba&scoped=true&"
import script from "./MaydayNodeMainBody.vue?vue&type=script&lang=js&"
export * from "./MaydayNodeMainBody.vue?vue&type=script&lang=js&"
import style0 from "./MaydayNodeMainBody.vue?vue&type=style&index=0&id=50e3a3ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e3a3ba",
  null
  
)

export default component.exports